module.exports = __webpack_public_path__ + "img/home-select-enquiry.be5e599e.jpg";